import React from 'react'
import moment from 'moment'
import api from '../../../apiClient/v1'
import ReactNotify from 'react-notify'
import * as ReactNotifyCSS from '../../../shared/ReactNotify/ReactNotify.css'
//Componentes
import { TableRendiciones } from './TableRendiciones.jsx'

//CSS
import css from '../../asignacion-fondos/Fondos.css'
import classNames from 'classnames/bind'
let cx = classNames.bind(css)
moment.locale('es')

export class RevisionRendiciones extends React.Component{
    constructor(props){
        super(props)
        this.state = {
            rendiciones : [],
            selectedWeek: '',
            numberWeek: 0,
            idLeader: 0,
            error: []
        }
        this.onWeekChange = (evt) => {
            this.setState({
                selectedWeek : evt.target.value,
                numberWeek : evt.target.value.substring(6,8),
                idLeader : 0
            }, ()=>this.getRendiciones())
        };
        this.onSelectLeaderChange = (evt) => {
            this.setState({
                idLeader: evt.target.value
            },()=>this.getRendiciones())
        }
        this.getRendiciones = () => {
            if(this.state.numberWeek){
                api.rendiciones().getRendiciones(this.state.idLeader, this.state.numberWeek)
                    .then(resp => {
                        this.setState({
                            rendiciones : resp
                        })
                    })
                    .catch(err=>{
                        console.log(err)
                    })
            }
        }
    }
    render() {
        return (
            <div className="container-fluid">
                <div className="panel panel-default">
                    <div className="panel-body">
                        <div className="page-header row">
                            <div className={cx("col-md-12", 'titleFinance')}>
                                <div className={cx("col-md-10", 'divTitle')}>
                                    <h3>Rendiciones enviadas por trabajadores</h3>
                                </div>
                                <div className={cx("col-md-1", 'divNavBar')}>
                                    <a className="btn btn-md btn-success"
                                       href={`/api/rendiciones/fondos/${this.state.numero_semana}/descargar-excel`}>
                                        <span className={'glyphicon glyphicon-export'}></span> Excel
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-12">
                            <div className={'col-md-2 form-group '}>
                                <label className="control-label" htmlFor="selectSemana">Seleccionar Semana</label>
                                <input type="week" className={"form-control "+css.inputGeneral}
                                       value={this.state.semanaSeleccionada}
                                       onChange={this.onWeekChange}/>
                                {this.state.error.fechas && <span className={cx('form__error-message')}>{this.state.error.fechas}</span>}
                            </div>
                            
                        </div>
                        {this.state.rendiciones.length === 0 ?
                            null
                            :
                            <div className={cx("col-md-12", 'divFinance')}>
                                <div className="row">
                                    <div className="col-md-11">
                                        <h5 className={css.textInformation}>Rendiciones encontradas en la semana seleccionada*</h5>
                                    </div>
                                </div>
                                <div className="row">
                                    <TableRendiciones
                                        rendiciones={this.state.rendiciones}
                                    />    
                                </div>
                            </div>
                        }
                    </div>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./frontEnd/contabilidad/revision-rendiciones/rendiciones/RevisionRendiciones.jsx